import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Agenda", path: "/agenda" },
  { label: "Speakers", path: "/speakers" },
  { label: "Intelligence", path: "/blog" },
  { label: "Awards", path: "/awards" },
  { label: "Expo", path: "/expo" },
  { label: "Sponsor", path: "/sponsor" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 bg-forest-core transition-all duration-200 ${
        scrolled ? "border-b-2 border-lemon-beam" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-1.5">
          <span className="text-lemon-beam font-extrabold text-base md:text-lg tracking-tight leading-tight">
            BioResources &<br className="hidden md:block" /> Circular Economy
          </span>
          <span className="text-white font-bold text-[10px] md:text-xs tracking-tight leading-tight hidden sm:block">
            Summit &<br />Expo 2026
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`navbar-${link.label.toLowerCase()}-link`}
              className={`text-sm font-semibold tracking-wide transition-colors duration-200 ${
                location.pathname === link.path
                  ? "text-lemon-beam"
                  : "text-white hover:text-lemon-beam"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:block">
          <Link
            to="/register"
            data-testid="navbar-register-btn"
            className="inline-block bg-lemon-beam text-forest-core font-bold text-sm px-6 py-2.5 rounded-[8px] hover:bg-gold transition-colors duration-200"
          >
            Claim Your Free Pass
          </Link>
        </div>

        <button
          data-testid="navbar-hamburger"
          className="md:hidden text-white"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {menuOpen && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden bg-forest-core border-t border-white/10 px-6 pb-6"
        >
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`mobile-${link.label.toLowerCase()}-link`}
              className={`block py-3 text-base font-semibold border-b border-white/5 ${
                location.pathname === link.path
                  ? "text-lemon-beam"
                  : "text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/register"
            data-testid="mobile-register-btn"
            className="mt-4 block text-center bg-lemon-beam text-forest-core font-bold text-sm px-6 py-3 rounded-[8px]"
          >
            Claim Your Free Pass
          </Link>
        </div>
      )}
      </nav>
  );
}
